module.exports = __webpack_public_path__ + "static/img/05046C_2_3_R_20180513_fit.522aecb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/05046C_2_3_R_20180513_fit.png
// module id = 7o8k
// module chunks = 0